"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CardHeader = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(_CardHeader.default, _extends({
    titleTypographyProps: {
      variant: 'subtitle1',
      gutterBottom: true
    },
    subheaderTypographyProps: {
      variant: 'body2',
      gutterBottom: true,
      color: 'inherit'
    }
  }, props, {
    ref: ref
  }));
});

var _default = CardHeader;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmQvQ2FyZEhlYWRlci50c3giXSwibmFtZXMiOlsiQ2FyZEhlYWRlciIsIlJlYWN0IiwiZm9yd2FyZFJlZiIsInByb3BzIiwicmVmIiwidmFyaWFudCIsImd1dHRlckJvdHRvbSIsImNvbG9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7Ozs7O0FBR0EsSUFBTUEsVUFBcUMsZ0JBQUdDLGVBQU1DLFVBQU4sQ0FBaUIsVUFBQ0MsS0FBRCxFQUFRQyxHQUFSO0FBQUEsc0JBQzdELDZCQUFDLG1CQUFEO0FBQ0UsSUFBQSxvQkFBb0IsRUFBRTtBQUFFQyxNQUFBQSxPQUFPLEVBQUUsV0FBWDtBQUF3QkMsTUFBQUEsWUFBWSxFQUFFO0FBQXRDLEtBRHhCO0FBRUUsSUFBQSx3QkFBd0IsRUFBRTtBQUFFRCxNQUFBQSxPQUFPLEVBQUUsT0FBWDtBQUFvQkMsTUFBQUEsWUFBWSxFQUFFLElBQWxDO0FBQXdDQyxNQUFBQSxLQUFLLEVBQUU7QUFBL0M7QUFGNUIsS0FHTUosS0FITjtBQUlFLElBQUEsR0FBRyxFQUFFQztBQUpQLEtBRDZEO0FBQUEsQ0FBakIsQ0FBOUM7O2VBU2VKLFUiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgQ2FyZEhlYWRlciBhcyBNdWlDYXJkSGVhZGVyLCBDYXJkSGVhZGVyUHJvcHMgfSBmcm9tICdAbWF0ZXJpYWwtdWkvY29yZSc7XG5cbmNvbnN0IENhcmRIZWFkZXI6IFJlYWN0LkZDPENhcmRIZWFkZXJQcm9wcz4gPSBSZWFjdC5mb3J3YXJkUmVmKChwcm9wcywgcmVmKSA9PiAoXG4gIDxNdWlDYXJkSGVhZGVyXG4gICAgdGl0bGVUeXBvZ3JhcGh5UHJvcHM9e3sgdmFyaWFudDogJ3N1YnRpdGxlMScsIGd1dHRlckJvdHRvbTogdHJ1ZSB9fVxuICAgIHN1YmhlYWRlclR5cG9ncmFwaHlQcm9wcz17eyB2YXJpYW50OiAnYm9keTInLCBndXR0ZXJCb3R0b206IHRydWUsIGNvbG9yOiAnaW5oZXJpdCcgfX1cbiAgICB7Li4ucHJvcHN9XG4gICAgcmVmPXtyZWZ9XG4gIC8+XG4pKTtcblxuZXhwb3J0IGRlZmF1bHQgQ2FyZEhlYWRlcjtcbiJdfQ==